module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00189.60ff9494.jpg";